import { GridColDef, GridValidRowModel } from '@mui/x-data-grid-pro';

interface GridColDefFactoryOptions {
  tColumn: (key: string, options?: Record<string, any>) => string;
  t?: (key: string, options?: Record<string, any>) => string;
  defaultOptions?: Partial<GridColDef>;
}

export const gridColDefFactory =
  ({ tColumn, t, defaultOptions }: GridColDefFactoryOptions) =>
  <R extends GridValidRowModel = any, V = any, F = V>(colDef: GridColDef<R, V, F>): GridColDef<R, V, F> => {
    const headerName = colDef.headerName ?? tColumn(colDef.field);
    return {
      display: 'flex',
      width: colDef.minWidth,
      headerAlign: colDef.align,
      headerName,
      description: colDef.sortable === false && t ? t('DataGrid.noSorting', { headerName }) : undefined,
      ...defaultOptions,
      ...colDef,
    };
  };
